import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Icon = styled(FontAwesomeIcon)`
  ${({ theme, color }) => color && `color: ${theme.color[color]};`}
  ${({ theme, pad }) => pad && `margin-${pad}: ${theme.space[1]};`}
`;

export default { Icon };
